var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pageUrl)?_c('a',{staticClass:"fits-with-drawer__ cta-link",attrs:{"href":_vm.pageUrl},on:{"click":function (e) { return _vm.showModal(e); }}},[_vm._v(_vm._s(_vm.websiteText('productpage.fitswithdrawer.linktext')))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }